import { render, staticRenderFns } from "./hotelResourceLeft.vue?vue&type=template&id=68c29029&scoped=true"
import script from "./hotelResourceLeft.vue?vue&type=script&lang=js"
export * from "./hotelResourceLeft.vue?vue&type=script&lang=js"
import style0 from "./hotelResourceLeft.vue?vue&type=style&index=0&id=68c29029&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c29029",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c29029')) {
      api.createRecord('68c29029', component.options)
    } else {
      api.reload('68c29029', component.options)
    }
    module.hot.accept("./hotelResourceLeft.vue?vue&type=template&id=68c29029&scoped=true", function () {
      api.rerender('68c29029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/child/hotelResourceLeft.vue"
export default component.exports